import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import {
    COURSE_ACTIVITY_REPORT,
    COURSE_GRADEBOOK_REPORT,
    COURSE_GRADES_REPORTS,
    COURSE_SCHEMA_REPORT,
    COURSE_TEMPLATE_SCHEMA_REPORT,
    COURSES_WITH_UNGRADED_SUBMISSIONS_REPORT,
    GROUP_COURSE_REPORT,
    GROUP_DISCUSSIONS_REPORT,
    INSTRUCTOR_DISCUSSIONS_REPORT,
    LATE_OR_MISSED_MEETINGS_REPORT,
    MEETING_COUNT_REPORT,
    MEETING_STATUS_REPORT,
    MISSING_COURSE_GRADES_REPORT,
    MISSING_SUBMISSIONS_REPORT,
    RISK_ASSESSMENT_REPORT,
    USER_ACTIVITY_REPORT,
    USER_IMPRESSIONS_REPORT,
} from '@/pages/reports/ReportPermissions.js';
import ReportPolicy from '@/policies/ReportPolicy.js';

export default [
    {
        path: '/reports',
        component: () => import('@/pages/reports/ReportsIndex.vue'),
        props: true,
        children: [
            {
                path: '',
                name: 'reports-index',
                component: () => import('@/pages/reports/ReportsIntroduction.vue'),
                props: true,
                meta: {
                    title: 'Reports',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'reports' },
                },
            },
            {
                path: '/reports/user-impressions-report',
                name: 'user-impressions-report',
                component: () => import('@/pages/reports/UserImpressionsReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, USER_IMPRESSIONS_REPORT);
                    },
                },
            },
            {
                path: '/reports/user-activity-report',
                name: 'user-activity-report',
                component: () => import('@/pages/reports/UserActivityReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, USER_ACTIVITY_REPORT);
                    },
                },
            },
            {
                path: '/reports/course-activity-report',
                name: 'course-activity-report',
                component: () => import('@/pages/reports/CourseActivityReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, COURSE_ACTIVITY_REPORT);
                    },
                },
            },
            {
                path: '/reports/course-gradebook-report',
                name: 'course-gradebook-report',
                component: () => import('@/pages/reports/CourseGradebookReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, COURSE_GRADEBOOK_REPORT);
                    },
                },
            },
            {
                path: '/reports/group-course-report',
                name: 'group-course-report',
                component: () => import('@/pages/reports/GroupCourseReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, GROUP_COURSE_REPORT);
                    },
                },
            },
            {
                path: '/reports/courses-with-ungraded-submissions-report',
                name: 'courses-with-ungraded-submissions-report',
                component: () => import('@/pages/reports/CoursesWithUngradedSubmissionsReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, COURSES_WITH_UNGRADED_SUBMISSIONS_REPORT);
                    },
                },
            },
            {
                path: '/reports/meeting-status-report',
                name: 'meeting-status-report',
                component: () => import('@/pages/reports/MeetingStatusReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, MEETING_STATUS_REPORT);
                    },
                },
            },
            {
                path: '/reports/late-or-missed-meetings-report',
                name: 'late-or-missed-meetings-report',
                component: () => import('@/pages/reports/LateOrMissedMeetingsReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, LATE_OR_MISSED_MEETINGS_REPORT);
                    },
                },
            },
            {
                path: '/reports/failed-course-report',
                name: 'failed-course-report',
                component: () => import('@/pages/reports/FailedCourseReport.vue'),
                props: true,
                meta: {
                    middleware: [],
                    ability: () => true,
                },
            },
            {
                path: '/reports/missing-submissions-report',
                name: 'missing-submissions-report',
                component: () => import('@/pages/reports/MissingSubmissionsReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, MISSING_SUBMISSIONS_REPORT);
                    },
                },
            },
            {
                path: '/reports/missing-submissions-report',
                name: 'missing-submissions-report',
                component: () => import('@/pages/reports/MissingSubmissionsReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, MISSING_SUBMISSIONS_REPORT);
                    },
                },
            },
            {
                path: '/reports/missing-course-grades-report',
                name: 'missing-course-grades-report',
                component: () => import('@/pages/reports/MissingCourseGradesReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, MISSING_COURSE_GRADES_REPORT);
                    },
                },
            },
            {
                path: '/reports/meeting-count-report',
                name: 'meeting-count-report',
                component: () => import('@/pages/reports/MeetingCountReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, MEETING_COUNT_REPORT);
                    },
                },
            },
            {
                path: '/reports/discussions-report/:view',
                name: 'discussions-report',
                component: () => import('@/pages/reports/DiscussionsReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return (
                            reportPolicy.view(gateKeeper.user, GROUP_DISCUSSIONS_REPORT) ||
                            reportPolicy.view(gateKeeper.user, INSTRUCTOR_DISCUSSIONS_REPORT)
                        );
                    },
                },
            },
            {
                path: '/reports/course-schema-report',
                name: 'course-schema-report',
                component: () => import('@/pages/reports/SchemaReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, COURSE_SCHEMA_REPORT);
                    },
                },
            },
            {
                path: '/reports/course-template-schema-report',
                name: 'course-template-schema-report',
                component: () => import('@/pages/reports/SchemaReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, COURSE_TEMPLATE_SCHEMA_REPORT);
                    },
                },
            },
            {
                path: '/reports/risk-assessment-report',
                name: 'risk-assessment-report',
                component: () => import('@/pages/reports/RiskAssessmentReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();

                        return reportPolicy.view(gateKeeper.user, RISK_ASSESSMENT_REPORT);
                    },
                },
            },
            {
                path: '/reports/course-grades-report',
                name: 'course-grades-report',
                component: () => import('@/pages/reports/CourseGradesReport.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        const reportPolicy = new ReportPolicy();
                        return reportPolicy.view(gateKeeper.user, COURSE_GRADES_REPORTS);
                    },
                },
            },
        ],
    },
];
